export namespace ScreeningQuestionnaireActions {
  const prefix = '[Screening Questionnaire]';

  export class SetQuestionValue {
    static readonly type = `${ prefix } Set question value`;

    constructor(public index: number, public value: number) {
    }
  }

  export class ClearQuestionValues {
    static readonly type = `${ prefix } Clear values from index`;

    constructor(public fromIndex: number) {
    }
  }

  export class ConfirmReferenceStartRegistration {
    static readonly type = `${ prefix } Confirm reference start registration`;

    constructor() {
    }
  }

  export class ConfirmReferralMissing {
    static readonly type = `${ prefix } Confirm referral missing`;

    constructor() {
    }
  }
}